module.exports = __webpack_public_path__ + "static/media/1POLICY40.0d4943fb.jpg";